/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { selectCommonState } from '../selectors';

export const selectSelectedLanguage = createSelector(
  selectCommonState,
  (uiState) => uiState.language
);
